import { Chip } from '@mui/material';
import React from 'react';

const TicketStatusChip = ({ status, hasActiveTask, isOpen }) => {
  const getStatusColor = () => {
    if (status?.code === 'NEW') {
      return 'error';
    }
    if (status?.code === 'INPROGRESS') {
      return 'warning';
    }
    if (status?.code === 'ABANDONNED') {
      return 'secondary';
    }
    if (status?.code === 'WAITING') {
      return hasActiveTask ? 'warning' : 'primary';
    }
    if (status?.code === 'PROCESSED') {
      return isOpen === false ? 'info' : 'success';
    }
    return 'default';
  };

  const getStatusLabel = () => {
    if (isOpen === false) {
      return 'Fermé';
    }
    if (status?.code === 'WAITING') {
      return `${status?.name} (${hasActiveTask ? 'interne' : 'client'})`;
    }
    return status?.name || 'Inconnu';
  };

  return (
    <Chip label={getStatusLabel()} color={getStatusColor()} size="small" />
  );
};

export default TicketStatusChip;
